import { getSupportedLanguages } from 'global/helpers/languages'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    load: 'currentOnly',
    fallbackLng: 'en',
    supportedLngs: getSupportedLanguages(),
    debug: ['dev', 'test'].includes(import.meta.env.MODE ?? ''),
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    returnNull: false,
    lowerCaseLng: true,
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?nocache=${Date.now()}`,
    },
  })

export default i18n
